import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ImportOrderDetail, ImportOrderDocument, UploadImportOrderDocumentRequest } from "src/app/domain/models/ImportOrder";
import { Routes } from "src/app/infrastructure/routes";
import { ImportOrderDetailGateway } from "../gateway/ImportOrderDetailGateway";
import { UpdateControlCompanyRequest } from "src/app/domain/models/QCCompany";
import { InstructiveInfo } from "src/app/domain/models/Pallet";

@Injectable({providedIn: 'root'})
export class ImportOrderDetailService extends ImportOrderDetailGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  getAllPendingForQCReviews(username: string): Observable<ImportOrderDetail[]> {
    return this._http.get<ImportOrderDetail[]>(Routes.importOrderDetailApi + '/GetAllPendingForQCReviews', {params: {username}})
  }

  getAllReviewedOriginQCReviews(username: string): Observable<ImportOrderDetail[]> {
    return this._http.get<ImportOrderDetail[]>(Routes.importOrderDetailApi + '/GetAllReviewedOriginQCReviews', {params: {username}})
  }

  getInstructiveDocument(detailId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type':  'application/octet-stream'
    })

    return this._http.get<any>(Routes.importOrderDetailApi + '/GenerateInstructive', {params: {detailId}, headers: headers, observe: 'response', responseType: 'blob' as 'json'})
  }

  getInstructiveDocumentPdf(detailId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type':  'application/pdf'
    })

    return this._http.post<any>(Routes.importOrderDetailApi + '/GenerateInstructivePdf',
      {logoUrl: null},
       {params: {detailId}, observe: 'response', responseType: 'blob' as 'json'})
  }

  getQcPayment(detailId: string):Observable<ImportOrderDetail>
  {
    return this._http.get<ImportOrderDetail>(Routes.importOrderDetailApi + '/GetQCPayment', {params: {detailId}});
  }

  updateQcCompany(updateQcCompany: UpdateControlCompanyRequest): Observable<any>
  {
    return this._http.put<any>(Routes.importOrderDetailApi + '/UpdateQcCompany', updateQcCompany);
  }

  removeQcPayment(importOrderDetailId: any): Observable<any>
  {
    return this._http.put<any>(Routes.importOrderDetailApi + '/RemoveQcPayment', {}, {params: {importOrderDetailId}})
  }

  getDownloadPackingList(importOrderDetailId: string): Observable<any> {
    return this._http.post<any>(Routes.deliveryApi + '/DownloadPackingList', {
      logoUrl: null
    },
      {params: {importOrderDetailId}, observe: 'response', responseType: 'blob' as 'json'})
  }

  getDownloadPackingListSwitch(importOrderDetailId: string, withLabel: boolean, withPackaging: boolean, withSpeciesSize: boolean): Observable<any> {

    return this._http.post<any>(Routes.deliveryApi + '/DownloadPackingList',
      {logoUrl: null},
      {params: {importOrderDetailId,withLabel,withPackaging,withSpeciesSize}, observe: 'response', responseType: 'blob' as 'json'})
  }

  getInstructiveInfo(importOrderDetailId: string, withLabel: boolean, withPackaging: boolean, withSpeciesSize: boolean):Observable<InstructiveInfo>{
    return this._http.get<InstructiveInfo>(Routes.importOrderDetailApi + '/GetInstructiveInfo', {params: {importOrderDetailId,withLabel,withPackaging,withSpeciesSize}});
  }

  getInstructivePreview(detailId: string):Observable<InstructiveInfo>{
    return this._http.get<InstructiveInfo>(Routes.importOrderDetailApi + '/GetInstructivePreview', {params: {detailId}});
  }

}
